<template>
  <!-- 战团管理-战团管理 -->
  <div class="battle_groups-box">
    <!-- header头部 -->
    <header>
      <el-form :inline="true" :model="query" class="demo-form-inline">
        <el-form-item>
          <el-input
            v-model="query.team_name"
            placeholder="请输入战团名称"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            v-model="query.team_id"
            placeholder="请输入战团id"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-select v-model="query.status">
            <el-option :value="undefined" label="请选择战团状态"
              >全部</el-option
            >
            <el-option :value="1" label="待审核"></el-option>
            <el-option :value="2" label="已通过"></el-option>
            <el-option :value="3" label="已拒绝"></el-option>
            <el-option :value="4" label="已取消"></el-option>
            <el-option :value="5" label="已解散"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getData(1)">查询</el-button>
        </el-form-item>
      </el-form>
    </header>
    <!-- body内容 -->
    <div class="body-box">
      <el-table :data="dataList" v-loading="loading">
        <el-table-column prop="id" label="战团UID" align="center">
        </el-table-column>
        <el-table-column prop="name" label="战团名称" align="center">
        </el-table-column>
        <el-table-column label="头像" align="center">
          <template slot-scope="{ row }">
            <img width="80" :src="row.avatar" alt="">
          </template>
        </el-table-column>
        <el-table-column prop="level" label="战团等级" align="center">
        </el-table-column>
        <el-table-column label="人数" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.num }}/{{ row.team_total_num }}</span>
          </template>
        </el-table-column>
        <el-table-column label="经验" align="center">
          <template slot-scope="{ row }">
            <span>{{ row.exp }}/{{ row.team_total_exp }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center">
          <template slot-scope="{ row }">
            <el-tag v-if="row.status === 1">待审核</el-tag>
            <el-tag type="success" v-if="row.status === 2">已通过</el-tag>
            <el-tag type="danger" v-if="row.status === 3">已拒绝</el-tag>
            <el-tag type="info" v-if="row.status === 4">已取消</el-tag>
            <el-tag type="info" v-if="row.status === 5">已解散</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="red_receive_amount"
          label="红包可发放总金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="red_send_amount"
          label="已发总金额"
          align="center"
        >
        </el-table-column>
        <el-table-column
          prop="red_remain_amount"
          label="返利总额"
          align="center"
        >
        </el-table-column>
        <el-table-column prop="aim" label="战团宗旨" align="center">
        </el-table-column>
        <el-table-column prop="created_at" label="创建日期" align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          align="center"
          width="200px"
          fixed="right"
        >
          <template slot-scope="{ row }">
            <el-col class="col-box" :span="30" v-if="row.status === 1">
              <el-button size="small" type="primary" @click="through(row)"
                >通过</el-button
              >
              <el-button size="small" type="danger" @click="refused(row)"
                >拒绝</el-button
              >
            </el-col>

            <el-col class="col-box" :span="30" v-if="row.status === 2">
              <el-button size="small" type="primary" @click="handleEdit(row)"
                >编辑战团</el-button
              >
              <el-dropdown style="margin-left: 10px" @command="bannedEvent">
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="{ rowInfo: row, command: 4 }"
                    >战团成员</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ rowInfo: row, command: 1 }"
                    >红包记录</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ rowInfo: row, command: 2 }"
                    >成员流动</el-dropdown-item
                  >
                  <el-dropdown-item :command="{ rowInfo: row, command: 3 }"
                    >解散</el-dropdown-item
                  >
                </el-dropdown-menu>
              </el-dropdown>
            </el-col>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页条 -->
      <el-pagination
        background
        :page-size="dataMeta.per_page || 15"
        :total="dataMeta.total || 0"
        :current-page="dataMeta.current_page"
        @current-change="handlePageChange"
        v-if="dataMeta && dataMeta.total > dataMeta.per_page"
      ></el-pagination>
    </div>

    <!-- 弹窗 -->
    <!-- 编辑战团 -->
    <EditObjective
      v-model="dialogInfos"
      :visible="editVisible"
      @close="editVisible = false"
      @refresh="getData"
    ></EditObjective>
    <!-- 红包记录 -->
    <RedEnvelopeRecord
      v-model="dialogInfos"
      :visible="redEnvelopeVisible"
      @close="redEnvelopeVisible = false"
    ></RedEnvelopeRecord>
    <!-- 人员流动 -->
    <MembersFlow
      v-model="dialogInfos"
      :visible="membersFlowVisible"
      @close="membersFlowVisible = false"
    ></MembersFlow>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import http, { server, api, delApiData, getApiData, postApiData, patchApiData } from '@/http'
import saveFile from '@/utils/saveFile'
import { getCookie } from '@/utils/cookie'
import RedEnvelopeRecord from '@/components/battle_groups/RedEnvelopeRecord.vue'
import MembersFlow from '@/components/battle_groups/MembersFlow.vue'
import EditObjective from '@/components/battle_groups/EditObjective.vue'

export default {
  name: 'battle_groups',
  components: {
    RedEnvelopeRecord,
    MembersFlow,
    EditObjective
  },
  data() {
    return {
      editVisible: false,//编辑战团弹窗记录显示标志
      redEnvelopeVisible: false,//红包弹窗记录显示标志
      membersFlowVisible: false,//人员流动弹窗记录显示标志
      dialogVisible: false,//弹窗显示标志
      loading: false,//加载动画
      buttonLoading: false,//按钮加载动画
      dialogLoading: false,//弹窗加载数据动画
      query: {//查询条件
        page: 1,
        team_id: undefined,
        team_name: '',
        status: undefined
      },
      dialogType: 1,//1是添加 2是修改 默认是1
      dialogInfos: undefined,//要传递的弹窗数据
      dataList: undefined,//列表数据
      dataMeta: undefined,//底部跳转页面条
    }
  },
  computed: {
    headers() {
      return {
        Authorization: 'Bearer ' + getCookie('access_token')
      }
    },
    action() {
      return `${api}member_card_user`
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData(num) {
      if (num === 1) {
        this.query.page = 1
      }
      this.loading = true
      let params = this.query
      getApiData('team_list', params).then(res => {
        if (res) {
          this.dataList = res.data
          //设置底部导航条数据
          this.dataMeta = {
            current_page: res.current_page,//当前页标
            per_page: res.per_page,//每页多少条
            total: res.total,//总数据条数
            total_pages: res.total_pages,//总页数
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    through(rowInfo) {
      //通过
      let params = {
        status: 2
      }
      patchApiData(`team_examine/${rowInfo.id}`, params).then(res => {
        if (res.code === 1) {
          this.$message.success(res.message)
          this.getData()
        } else {
          this.$message.error(res.message)
        }
      }).finally(() => {
      })
    },
    refused(rowInfo) {
      //拒绝
      this.$confirm(`确定要拒绝<${rowInfo.name}>的创建申请吗？`, {
        type: 'warning'
      }).then(res => {
        let params = {
          status: 3
        }
        patchApiData(`team_examine/${rowInfo.id}`, params).then(res => {
          if (res.code === 1) {
            this.$message.success(res.message)
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    handleEdit(rowInfo) {
      //编辑战团
      this.editVisible = true
      this.dialogInfos = JSON.parse(JSON.stringify(rowInfo))
    },
    dissolution(rowInfo) {
      // 解散
      this.$confirm(`确定要解散<${rowInfo.name}>吗？`, {
        type: 'warning'
      }).then(res => {
        let params = {
          status: 5
        }
        patchApiData(`team_examine/${rowInfo.id}`, params).then(res => {
          if (res.code === 1) {
            this.$message.success(res.message)
            this.getData()
          } else {
            this.$message.error(res.message)
          }
        })
      })
    },
    bannedEvent(commandInfo) {
      //更多操作
      if (commandInfo.command === 1) {
        // 红包记录
        this.redEnvelopeVisible = true
        this.dialogInfos = JSON.parse(JSON.stringify(commandInfo.rowInfo))
      }
      if (commandInfo.command === 2) {
        // 成员流动
        this.membersFlowVisible = true
        this.dialogInfos = JSON.parse(JSON.stringify(commandInfo.rowInfo))
      }
      if (commandInfo.command === 3) {
        //解散
        this.dissolution(commandInfo.rowInfo)
      }
      if (commandInfo.command === 4) {
        //战团成员
        let routeData = this.$router.resolve({
          path: `/battle_user`,
          query: { id: commandInfo.rowInfo.id }
        })
        window.open(routeData.href, '_blank')
      }
    },
    handlePageChange(page) {
      //页面底部跳转页面
      this.query.page = page
      this.getData()
    },
  },
}
</script>

<style lang="less" scoped>
.battle_groups-box {
  header {
  }

  .body-box {
    .col-box {
      display: flex;
      justify-content: center;
    }
  }
}
</style>